import { AuthStepItemType } from '../types';
import { PasswordStepItem } from './stepItems/PasswordStepItem';
import { TextStepItem } from './stepItems/TextStepItem';
import { EmailStepItem } from './stepItems/EmailStepItem';
import { HtmlStepItem } from './stepItems/HtmlStepItem';
import { InfoBlockStepItem } from './stepItems/InfoBlockStepItem';
import { SelectStepItem } from './stepItems/SelectStepItem';
import { SnippetStepItem } from './stepItems/SnippetStepItem';
import { UrlStepItem } from './stepItems/UrlStepItem';
import { jsx as _jsx } from "react/jsx-runtime";
export function AuthStepItemView({
  item,
  label,
  params,
  onChange
}) {
  switch (item.type) {
    case AuthStepItemType.Password:
      return /*#__PURE__*/_jsx(PasswordStepItem, {
        item: item,
        label: label,
        params: params,
        onChange: onChange
      });
    case AuthStepItemType.Text:
      return /*#__PURE__*/_jsx(TextStepItem, {
        item: item,
        label: label,
        params: params,
        onChange: onChange
      });
    case AuthStepItemType.Email:
      return /*#__PURE__*/_jsx(EmailStepItem, {
        item: item,
        label: label,
        params: params,
        onChange: onChange
      });
    case AuthStepItemType.Html:
      return /*#__PURE__*/_jsx(HtmlStepItem, {
        item: item,
        label: label
      });
    case AuthStepItemType.InfoBlock:
      return /*#__PURE__*/_jsx(InfoBlockStepItem, {
        item: item,
        label: label
      });
    case AuthStepItemType.Select:
      return /*#__PURE__*/_jsx(SelectStepItem, {
        item: item,
        label: label,
        params: params,
        onChange: onChange
      });
    case AuthStepItemType.Snippet:
      return /*#__PURE__*/_jsx(SnippetStepItem, {
        item: item,
        label: label
      });
    case AuthStepItemType.Url:
      return /*#__PURE__*/_jsx(UrlStepItem, {
        item: item,
        label: label,
        params: params,
        onChange: onChange
      });
    default:
      return null;
  }
}